import { DocumentInfo } from '@borg/types';

class DocumentInfoRepository extends Repository<DocumentInfo> {
  get(id: Ref<number | undefined>) {
    return this._get({ url: () => `/documents/${id.value}`, immediate: false });
  }
}

export const documentInfoRepository = new DocumentInfoRepository();
